<template>
  <div class="mb-3">
    <label :for="id" class="form-label">{{ label }}{{ required ? ' *' : '' }}</label>
    
    <!-- Input de texto, email, password -->
    <input 
      v-if="type === 'text' || type === 'email' || type === 'password'" 
      :type="type" 
      :class="['form-control', readonly ? 'readonly-field' : '']"
      :id="id" 
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :required="required"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :readonly="readonly"
    >
    
    <!-- Input numérico -->
    <input 
      v-else-if="type === 'number'" 
      type="number" 
      :class="['form-control', readonly ? 'readonly-field' : '']"
      :id="id" 
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value ? parseFloat($event.target.value) : null)"
      :required="required"
      :step="step"
      :min="min"
      :max="max"
      :placeholder="placeholder"
      :readonly="readonly"
    >
    
    <!-- Textarea -->
    <textarea 
      v-else-if="type === 'textarea'" 
      :class="['form-control', readonly ? 'readonly-field' : '']"
      :id="id" 
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :required="required"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :readonly="readonly"
      :rows="rows"
    ></textarea>
    
    <!-- Select -->
    <select 
      v-else-if="type === 'select'" 
      :class="['form-select', readonly ? 'readonly-field' : '']"
      :id="id" 
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
      :required="required"
      :disabled="readonly"
    >
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option 
        v-for="option in options" 
        :key="option.value" 
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    
    <!-- Checkbox -->
    <div v-else-if="type === 'checkbox'" class="form-check">
      <input 
        type="checkbox" 
        class="form-check-input" 
        :id="id" 
        :checked="modelValue"
        @change="$emit('update:modelValue', $event.target.checked)"
        :disabled="readonly"
      >
      <label class="form-check-label" :for="id">{{ checkboxLabel || label }}</label>
    </div>
    
    <!-- Date/Datetime -->
    <input 
      v-else-if="type === 'date' || type === 'datetime-local'" 
      :type="type" 
      :class="['form-control', readonly ? 'readonly-field' : '']"
      :id="id" 
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :required="required"
      :disabled="readonly"
    >
    
    <!-- Mensaje de ayuda -->
    <small v-if="helpText" class="form-text text-muted">{{ helpText }}</small>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => [
        'text', 'email', 'password', 'number', 'textarea', 'select', 
        'checkbox', 'date', 'datetime-local'
      ].includes(value)
    },
    modelValue: {
      type: [String, Number, Boolean, Date],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [Number, String],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    helpText: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
      // Formato esperado: [{ value: 'valor', label: 'Etiqueta' }, ...]
    },
    checkboxLabel: {
      type: String,
      default: ''
    },
    rows: {
      type: [Number, String],
      default: 3
    },
    step: {
      type: [Number, String],
      default: null
    },
    min: {
      type: [Number, String],
      default: null
    },
    max: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['update:modelValue']
}
</script>
